import { render, staticRenderFns } from "./EditNfeForm.vue?vue&type=template&id=bec0bb40"
import script from "./EditNfeForm.vue?vue&type=script&lang=js"
export * from "./EditNfeForm.vue?vue&type=script&lang=js"
import style0 from "./EditNfeForm.vue?vue&type=style&index=0&id=bec0bb40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports